import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import ForgotPasswordResponse from "../pages/ForgotPasswordResponse";
import RenderMessage from "../pages/RenderMessage";
import Relogin from "../pages/Relogin";
import Logout from "../pages/Logout";
import ResetPasswordResponse from "../pages/ResetPasswordResponse";
import Unlock from "../pages/Unlock";
import UnlockResponse from "../pages/UnlockResponse";

const RouterPaths: React.FC = () => {
  const baseNamePath = process.env.REACT_APP_URL || '/wmlogin';
  return (
    <BrowserRouter basename={baseNamePath}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgotPasswordResponse" element={<ForgotPasswordResponse />} />
        <Route path="/resetPassword/:key" element={<ResetPassword />} />
        <Route path="/renderMessages" element={<RenderMessage />} />
        <Route path="/relogin" element={<Relogin />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/resetPasswordResponse" element={<ResetPasswordResponse />} />
        <Route path="/unlock/:key" element={<Unlock />} />
        <Route path="/unlockResponse" element={<UnlockResponse />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterPaths; 